<template>
  <v-app :class="'sidebar-mini ' +  globalFontTable" data-app :style="'font-size: ' + globalFontsize + '!important'">
    <notifications></notifications>
    <router-view></router-view>
  </v-app>
</template>

<script>
import {EventBus} from "@/utils/eventBus";

import('sweetalert2/dist/sweetalert2.css');
import('vue-notifyjs/themes/default.css');

export default {
  name: "App",
  created() {
    EventBus.$on('handleChangeGlobalFontSize', (value) => {
      this.globalFontsize = value.size;
       if (value.size === '0.8rem') {
        this.globalFontTable = 'small-table weather-fs-sm box-title-sm'
      } else if (value.size === '1.4rem') {
        this.globalFontTable = 'large-table weather-fs-lg box-title-lg'
      } else {
        this.globalFontTable = 'normal-table weather-fs box-title'
      }
    })
  },
  data() {
    return {
      globalFontsize: '1.2rem',
      globalFontTable: 'normal-table'
    }
  }
};
</script>
<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }

  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }

  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }

  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}

.small-table {
  table thead tr th {
    font-size: 1rem !important;

  }

  table tbody tr td {
    font-size: 1rem !important;
  }
}

.normal-table {
  table thead tr th {
    font-size: 1.15rem !important;

  }

  table tbody tr td {
    font-size: 1.15rem !important;
  }
}

.large-table {
  table thead tr th {
    font-size: 1.3rem !important;
  }

  table tbody tr td {
    font-size: 1.3rem !important;
  }
}

.weather-fs-sm .card-header .card-title {
  font-size: 1rem
}

.weather-fs-lg .card-header .card-title {
  font-size: 1.4rem
}

.weather-fs .card-header .card-title {
  font-size: 1.2rem
}

$box-title-sz: 1rem;

.box-title-fs {
  @if $box-title-sz == 0.8rem {
    .small-box .inner .box-title-sm {
      font-size: 0.8rem
    }
  } @else if box-title-sz == 1.4rem {
    .small-box .inner .box-title-lg {
      font-size: 1.2rem
    }
  } @else {
    .small-box .inner .box-title {
      font-size: 1rem
    }
  }
}

h6 {
  color: black !important;
}

body {
  font-weight: 500 !important;
  font-size: 1.4rem !important;
  line-height: 1.5 !important;
  font-style: adjust-color(black);
}
.vue-notifyjs .alert[data-notify="container"] {
  min-width: 400px !important; 
  max-width: 400px !important; 
  padding: 10px !important; 
  text-align: left  !important;
}
.notifications {
  position: fixed !important;
  top: 10px !important; 
  left: 50% !important;
  transform: translateX(-50%) !important; 
  width: 400px !important; 
  z-index: 9999 !important;
}

.vue-notifyjs .alert-error {
  background-color: #e57373 !important; 
  color: #fff !important;
  border: 1px solid #d32f2f !important;
}

.vue-notifyjs .alert-warning {
  background-color: #ffeb3b !important;
  color: #212529 !important;
  border: 1px solid #fbc02d !important;
}

.vue-notifyjs .alert-success {
  background-color: #81c784 !important; 
  color: #fff !important;
  border: 1px solid #388e3c !important;
}


@media (max-width: 500px) {
  .vue-notifyjs .alert[data-notify="container"] {
    min-width: 300px !important; 
    max-width: 300px !important; 
    padding: 10px !important; 
    text-align: left  !important;
  }
  .notifications {
    position: fixed !important;
    top: 10px !important; 
    left: 50% !important;
    transform: translateX(-50%) !important; 
    width: 300px !important; 
    z-index: 9999 !important;
  }
  .notifications .title{
    font-size: 14px !important;
  }
}

// .v-application--wrap {
//   max-width: none !important;
// }
</style>
